module.exports = __webpack_public_path__ + "static/media/leptophyes_punctatissima_002_APA.7b183566.png";